<template>
    
    <div class="accordion" id="pmFormAccordion">
        
        <!-- General Information Section -->
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button 
                    class="accordion-button accordion-button-sm" 
                    :class="{ collapsed: !sections.generalInfo }"
                    type="button" 
                    @click="toggleSection('generalInfo')"
                >
                    PM Information
                </button>
            </h2>
            <div class="accordion-collapse collapse" :class="{ show: sections.generalInfo }">
                <div class="accordion-body">
                    <!-- Basic Information -->
                    <div class="row">
                        <div class="col-6">
                            <kt-input
                                type="text"
                                label="PM Title" 
                                input-class="form-control form-control-sm"
                                v-model="model.Title"
                                placeholder="PM Title"
                            ></kt-input>
                        </div>
                        <div class="col-6">
                            <kt-select
                                v-model="model.PMType"
                                :options="pmTypeList"
                                label="PM Type"
                                label-key="label"
                                value-key="value"
                                input-class="form-control form-control-sm"
                                placeholder="Choose PM Type"
                            ></kt-select>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-6">
                            <label class="d-block">
                                Choose Client
                            </label>
                            <client-ac v-model="model.Customer" input-class="form-control form-control-sm"></client-ac>
                        </div>
                        <div class="col-6">
                            <tech-select 
                                label="Assign Technician"
                                :active="1" 
                                v-model="model.AssignedTechnician"
                            ></tech-select>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-6">
                            <kt-input
                                type="text"
                                label="Location" 
                                input-class="form-control form-control-sm"
                                v-model="model.Location"
                                placeholder="Location"
                            ></kt-input>
                        </div>
                        <div class="col-6">
                            <kt-input
                                type="text"
                                label="Equipment Name" 
                                input-class="form-control form-control-sm"
                                v-model="model.EquipmentName"
                                placeholder="Equipment Name"
                            ></kt-input>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-6">
                            <kt-input
                                type="text"
                                label="Asset Number" 
                                input-class="form-control form-control-sm"
                                v-model="model.AssetNumber"
                                placeholder="Asset Number"
                            ></kt-input>
                        </div>
                        <div class="col-3">
                            <label class="d-block small text-muted">Active</label>
                            <input 
                                type="checkbox" 
                                class="form-check-input" 
                                v-model="model.IsActive"
                                :true-value="true"
                                :false-value="false"
                            />
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col">
                            <kt-input
                                type="textarea"
                                label="Description" 
                                input-class="form-control form-control-sm"
                                v-model="model.Description"
                                placeholder="PM Description"
                                :rows="3"
                            ></kt-input>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col">
                            <kt-input
                                type="textarea"
                                label="Instructions" 
                                input-class="form-control form-control-sm"
                                v-model="model.Instructions"
                                placeholder="Maintenance Instructions"
                                :rows="4"
                            ></kt-input>
                        </div>
                    </div>

                    <!-- Scheduling Section -->
                    <div class="row mt-3">
                        <div class="col-12">
                            <h6 class="text-muted mb-2">Scheduling</h6>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <kt-select
                                v-model="model.FrequencyType"
                                :options="frequencyTypeList"
                                label="Frequency Type"
                                label-key="label"
                                value-key="value"
                                placeholder="Choose Frequency"
                            ></kt-select>
                        </div>
                        <div class="col-4">
                            <kt-input
                                type="number"
                                label="Frequency Value"
                                input-class="form-control form-control-sm"
                                v-model="model.FrequencyValue"
                                placeholder="e.g., 2 for every 2 weeks"
                            ></kt-input>
                        </div>
                        <div class="col-4">
                            <kt-input
                                type="number"
                                label="Estimated Duration (Hours)"
                                input-class="form-control form-control-sm"
                                v-model="model.EstimatedDurationHours"
                                placeholder="0.00"
                                step="0.5"
                            ></kt-input>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-4">
                            <kt-input
                                type="date"
                                label="Next Due Date"
                                input-class="form-control form-control-sm"
                                v-model="model.NextDueDate"
                            ></kt-input>
                        </div>
                        <div class="col-4">
                            <kt-input
                                type="date"
                                label="Last Completed Date"
                                input-class="form-control form-control-sm"
                                v-model="model.LastCompletedDate"
                            ></kt-input>
                        </div>
                        <div class="col-4">
                            <kt-input
                                type="number"
                                label="Days Before Due Notification"
                                input-class="form-control form-control-sm"
                                v-model="model.DaysBeforeDueNotification"
                                placeholder="7"
                            ></kt-input>
                        </div>
                    </div>

                    <!-- Cost Tracking Section -->
                    <div class="row mt-3">
                        <div class="col-12">
                            <h6 class="text-muted mb-2">Cost Tracking</h6>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <kt-input
                                type="number"
                                label="Estimated Cost"
                                input-class="form-control form-control-sm"
                                v-model="model.EstimatedCost"
                                placeholder="0.00"
                                step="0.01"
                            ></kt-input>
                        </div>
                        <div class="col-6">
                            <kt-input
                                type="number"
                                label="Actual Cost"
                                input-class="form-control form-control-sm"
                                v-model="model.ActualCost"
                                placeholder="0.00"
                                step="0.01"
                            ></kt-input>
                        </div>
                    </div>

                    <!-- Completion Section -->
                    <div class="row mt-3" v-if="model.Id">
                        <div class="col-12">
                            <h6 class="text-muted mb-2">Completion Details</h6>
                        </div>
                    </div>

                    <div class="row" v-if="model.Id">
                        <div class="col-4">
                            <kt-input
                                type="date"
                                label="Completion Date"
                                input-class="form-control form-control-sm"
                                v-model="model.CompletionDate"
                            ></kt-input>
                        </div>
                        <div class="col-4">
                            <kt-input
                                type="number"
                                label="Actual Duration (Hours)"
                                input-class="form-control form-control-sm"
                                v-model="model.ActualDurationHours"
                                placeholder="0.00"
                                step="0.5"
                            ></kt-input>
                        </div>
                        <div class="col-4">
                            <kt-select
                                v-model="model.CompletionStatus"
                                :options="completionStatusList"
                                label="Completion Status"
                                label-key="label"
                                value-key="value"
                                placeholder="Choose Status"
                            ></kt-select>
                        </div>
                    </div>

                    <div class="row mt-2" v-if="model.Id">
                        <div class="col">
                            <kt-input
                                type="textarea"
                                label="Completion Notes"
                                input-class="form-control form-control-sm"
                                v-model="model.CompletionNotes"
                                placeholder="Completion Notes"
                                :rows="3"
                            ></kt-input>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <!-- Related Records Tabs (Tasks, Parts, Expenses, Mileage, Assets) -->
    <div class="row mt-4" v-if="model.LinkedRequestId">
        <div class="col">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                    <button 
                        class="nav-link" 
                        :class="{ active: activeTab === 'time' }"
                        @click="activeTab = 'time'"
                        type="button"
                    >
                        Tasks
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button 
                        class="nav-link" 
                        :class="{ active: activeTab === 'parts' }"
                        @click="activeTab = 'parts'"
                        type="button"
                    >
                        Parts
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button 
                        class="nav-link" 
                        :class="{ active: activeTab === 'expenses' }"
                        @click="activeTab = 'expenses'"
                        type="button"
                    >
                        Expenses
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button 
                        class="nav-link" 
                        :class="{ active: activeTab === 'mileage' }"
                        @click="activeTab = 'mileage'"
                        type="button"
                    >
                        Mileage
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button 
                        class="nav-link" 
                        :class="{ active: activeTab === 'assets' }"
                        @click="activeTab = 'assets'"
                        type="button"
                    >
                        Assets
                    </button>
                </li>
            </ul>

            <div class="tab-content border border-top-0 p-3 bg-light">
                <!-- Tasks Tab -->
                <div v-show="activeTab === 'time'">
                    <time-list 
                        :request-id="model.LinkedRequestId"
                        :client-id="model.Customer"
                        :tech-id="model.AssignedTechnician"
                        :hide-filters="true"
                        :embedded="true"
                        :pm-only="true"
                    ></time-list>
                </div>

                <!-- Parts Tab -->
                <div v-show="activeTab === 'parts'">
                    <part-list 
                        :request-id="model.LinkedRequestId"
                        :client-id="model.Customer"
                        :tech-id="model.AssignedTechnician"
                        :hide-filters="true"
                        :embedded="true"
                        :pm-only="true"
                    ></part-list>
                </div>

                <!-- Expenses Tab -->
                <div v-show="activeTab === 'expenses'">
                    <expense-list 
                        :request-id="model.LinkedRequestId"
                        :client-id="model.Customer"
                        :tech-id="model.AssignedTechnician"
                        :hide-filters="true"
                        :embedded="true"
                        :pm-only="true"
                    ></expense-list>
                </div>

                <!-- Mileage Tab -->
                <div v-show="activeTab === 'mileage'">
                    <mileage-list 
                        :request-id="model.LinkedRequestId"
                        :client-id="model.Customer"
                        :tech-id="model.AssignedTechnician"
                        :hide-filters="true"
                        :embedded="true"
                        :pm-only="true"
                    ></mileage-list>
                </div>

                <!-- Assets Tab -->
                <div v-show="activeTab === 'assets'">
                    <kt-upload 
                        @process="processFiles($event)"
                        multiple="1"    
                    ></kt-upload>

                    <table class="table table-sm table-striped mt-3" v-if="files.length">
                        <thead>
                            <tr>
                                <th style="width: 80px">Actions</th>
                                <th>File Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="file in files" :key="file.Id">
                                <td>
                                    <button class="btn btn-sm btn-outline-danger" @click="showDelete(file)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                                <td>
                                    <a :href="'https://radarapp.7thleveltech.com/v1/Data/Download/' + file.Id" target="_blank">
                                        {{ file.Title }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!files.length" class="alert alert-secondary mt-3">
                        <i class="fa fa-file"></i> No files uploaded yet.
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import Api from "@/services/Api";
import Alert from "@/services/Alert";
import ClientAc from "@/components/Clients/ClientAc.vue";
import TechSelect from "@/components/Techs/TechSelect.vue";
import KtInput from "@/components/UI/KtInput.vue";
import KtSelect from "@/components/UI/KtSelect.vue";
import KtUpload from "@/components/UI/KtUpload.vue";
import TimeList from "@/components/Time/TimeList.vue";
import PartList from "@/components/Parts/PartList.vue";
import ExpenseList from "@/components/Expenses/ExpenseList.vue";
import MileageList from "@/components/Mileage/MileageList.vue";

const pmTypeList = [
    { label: "Inspection", value: "Inspection" },
    { label: "Maintenance", value: "Maintenance" },
    { label: "Calibration", value: "Calibration" },
    { label: "Safety Check", value: "Safety Check" },
    { label: "Cleaning", value: "Cleaning" },
    { label: "Lubrication", value: "Lubrication" },
    { label: "Testing", value: "Testing" },
    { label: "Other", value: "Other" }
];

const frequencyTypeList = [
    { label: "Daily", value: "Daily" },
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
    { label: "Quarterly", value: "Quarterly" },
    { label: "Yearly", value: "Yearly" },
    { label: "Custom", value: "Custom" },
    { label: "Meter-Based", value: "Meter-Based" }
];

const completionStatusList = [
    { label: "Pending", value: "Pending" },
    { label: "In Progress", value: "In Progress" },
    { label: "Completed", value: "Completed" },
    { label: "Overdue", value: "Overdue" },
    { label: "Skipped", value: "Skipped" }
];

const sections = ref({
    generalInfo: true
});

const toggleSection = (sectionName) => {
    sections.value[sectionName] = !sections.value[sectionName];
};

// Active tab state for child entity tabs
const activeTab = ref('time');

// File management
const files = ref([]);

const model = defineModel({
    type: Object,
    default: { }
});

// Load files when LinkedRequestId changes
watch(() => model.value.LinkedRequestId, async (newVal) => {
    if (newVal) {
        await loadFiles();
    }
}, { immediate: true });

const loadFiles = async () => {
    if (!model.value.LinkedRequestId) {
        files.value = [];
        return;
    }

    try {
        const response = await Api.loadAssets({
            RequestId: model.value.LinkedRequestId,
            Size: 9999
        });
        files.value = response || [];
    } catch (error) {
        console.error("Error loading files:", error);
        files.value = [];
    }
};

const processFiles = async (uploadedFiles) => {
    if (!model.value.LinkedRequestId) {
        Alert.notify({
            text: "Please save the PM first before uploading files.",
            type: "warning"
        });
        return;
    }

    for (const file of uploadedFiles) {
        try {
            await Api.saveAsset({
                RequestId: model.value.LinkedRequestId,
                Title: file.name,
                FileUrl: file.url,
                FileType: file.type || "application/octet-stream"
            });
        } catch (error) {
            console.error("Error saving file:", error);
        }
    }

    await loadFiles();
    Alert.notify({
        text: "Files uploaded successfully!",
        type: "success"
    });
};

const showDelete = async (file) => {
    Alert.confirm("Are you sure you want to delete this file?", async () => {
        try {
            await Api.deleteAsset(file.Id);
            await loadFiles();
            Alert.notify({
                text: "File deleted successfully!",
                type: "success"
            });
        } catch (error) {
            console.error("Error deleting file:", error);
            Alert.notify({
                text: "Error deleting file.",
                type: "error"
            });
        }
    });
};

</script>

<style scoped>
/* Grey background for accordion bodies */
.accordion-body {
    background-color: #f8f9fa;
}

.accordion-item {
    background-color: #ffffff;
}

.accordion-button {
    background-color: #e0e0e0;
    color: #111;
}

.accordion-button:hover {
    background-color: #e0e0e0;
    color: #111;
}
</style>
